import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';

import { IFilterItem } from '../../filter.interface';
import { DropDownItem, ISelect } from './../../filter.interface';

@Component({
  selector:
    '[formGroup] dropdown-filter-item, [formGroupName] dropdown-filter-item',
  templateUrl: './dropdown-filter-item.component.html',
})
export class DropdownFilterItemComponent implements OnInit {
  @Input() filterItem: IFilterItem;
  @Input() values?: DropDownItem[];

  filtersForm: UntypedFormGroup;
  items?: DropDownItem[];

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.filtersForm = this.controlContainer.control as UntypedFormGroup;
    this.items = this.values ?? (this.filterItem as ISelect).values;

    const control = this.filtersForm.get(this.filterItem.name);
    const cotrolValue = control?.value;

    if (cotrolValue === null) {
      control?.setValue('');
    }
  }
}
